import type { RegistryEntry } from '../../types';
import { nanoBananaConfigs } from './nano-banana';
import { imagenConfigs } from './imagen';

export const googleConfigs: Record<string, RegistryEntry> = {
  ...nanoBananaConfigs,
  ...imagenConfigs,
};